<template>
    <div>
        <div v-if="privilege">
            <v-tooltip right :disabled="privilege.level !==  'GROUP'">
                <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        label
                        small
                        color="teal"
                        outlined
                        v-bind="attrs"
                        v-on="on"
                    >
                        <strong>
                            {{ $t(`privilege.level.${privilege.level}`) }}
                        </strong>
                    </v-chip>
                </template>
                <ul
                    v-for="(name, index) in privilege.organizationalChartNames"
                    :key="`org-${index}`"
                >
                    <li>{{ name }}</li>
                </ul>
            </v-tooltip>

            <v-btn
                v-if="privilege.affectationByLevel && editMode"
                icon
                color="orange"
                @click="$emit('cogClick')"
            >
                <v-icon>mdi-cog</v-icon>
            </v-btn>

            <v-btn
                v-if="editMode"
                icon
                color="red"
                @click="$emit('trashCanClick')"
            >
                <v-icon>mdi-trash-can</v-icon>
            </v-btn>
        </div>
        <div v-else>
            <v-simple-checkbox
                v-if="editMode"
                @input="$emit('checkboxClick')"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "PrivilegeAction",
    props: {
        privilege: Object,
        editMode: Boolean,
    }
}
</script>

<style scoped>

</style>